import React from "react";

export const LazyTimeSince = React.lazy(() =>
    import(/* webpackChunkName: "TimeSince" */ "./TimeSince").then(module => ({
        default: module.TimeSince
    }))
);
